import React from 'react';
import { Price, RegularButton, Typography } from 'fronton-react';
import { getPriceText } from 'utils';
import { btnStyles, CardPriceWrapper, FlexRow, priceRedline } from './styled';
import { TypographyProps } from 'fronton-react/typography/types';

type CardPriceProps = {
	price: number;
	unit?: string;
	flexiblePrice?: boolean;
	className?: string;
	mainPriceColor?: TypographyProps['color'];
	oldPrice?: number;
};

export const CardPrice = ({
	price,
	flexiblePrice = true,
	unit = null,
	className = '',
	mainPriceColor,
	oldPrice,
}: CardPriceProps) => (
	<CardPriceWrapper className={className}>
		<FlexRow>
			<div data-analyticsName="productPriceLink">
				{flexiblePrice && (
					<Typography variant="s" size="body_accent" color={mainPriceColor}>
						от&nbsp;
					</Typography>
				)}
				<Typography
					variant="l"
					size="body_accent"
					data-qa="card-price"
					color={mainPriceColor}
				>
					{getPriceText(price)}
				</Typography>
				<Typography
					variant="s"
					size="body_accent"
					data-qa="card-unit"
					color={mainPriceColor}
				>
					&nbsp;₽{unit && `/${unit}`}
				</Typography>
			</div>
			{!!oldPrice && (
				<Price value={oldPrice} variant="medium" size="s" className={priceRedline} />
			)}
		</FlexRow>

		<RegularButton
			variant="primary"
			size="s"
			className={btnStyles}
			data-qa="card-order-btn"
			data-analyticsName="productButtonLink"
		>
			Заказать
		</RegularButton>
	</CardPriceWrapper>
);
